import { createContext, type ReactNode, useContext, useState } from "react"

function usePermissionPreviewState() {
	const [selection, setSelection] = useState<{
		scope: "organization" | "team"
		scopeId: string
		roleId: string
	} | null>(null)
	return { selection, setSelection }
}

const PermissionPreviewContext = createContext<ReturnType<
	typeof usePermissionPreviewState
> | null>(null)

export function PermissionPreviewProvider({
	children
}: {
	children: ReactNode
}) {
	const value = usePermissionPreviewState()
	return (
		<PermissionPreviewContext value={value}>
			{children}
		</PermissionPreviewContext>
	)
}

export function usePermissionPreview() {
	return useContext(PermissionPreviewContext)
}
